// removed by extract-text-webpack-plugin
module.exports = {"news-item":"_2JeeuPip","newsItem":"_2JeeuPip","inner":"_2xEDypbI","publisher":"_2DcoMgTr","date":"_15EpVSCR","title":"Pn2EWgKW","sub-title":"Gi3Zdwmz","subTitle":"Gi3Zdwmz","img-wrap":"_1h9IGmEG","imgWrap":"_1h9IGmEG","txt-wrap":"_2u11lx-t","txtWrap":"_2u11lx-t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsSection/NewsItem/NewsItem.pcss
// module id = 420
// module chunks = 0